import { useLayoutEffect } from 'react';

function useMount(callback: () => void): void {
  useLayoutEffect(() => {
    callback();
    // @ts-ignore
  }, []);
}

export default useMount;
